export default __webpack_public_path__ + "static/realWorldImg3-967067583abd1b85cefe5eb1667587f4.webp";